import type { Transfert } from '../../api/types';
import { ETAT_TRANSFERT, ETAT_TRANSFERT_VARIANT } from '../../lib/labels';
import { formatDate } from '../../lib/format';
import { Badge, EmptyState, Section } from '../ui';

export default function TransfertsSection({ transferts }: { transferts: Transfert[] }) {
  return (
    <Section title="Transferts">
      {transferts.length === 0 ? (
        <EmptyState>Aucun transfert pour cette commande.</EmptyState>
      ) : (
        <ul className="space-y-2">
          {transferts.map((transfert) => (
            <li key={transfert.id} className="rounded-lg border border-card-border bg-surface-inset p-3 text-sm">
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant={ETAT_TRANSFERT_VARIANT[transfert.etat] ?? 'outline'}>
                  {ETAT_TRANSFERT[transfert.etat] ?? transfert.etat}
                </Badge>
                <span className="text-on-surface-variant">
                  Billet {transfert.idBillet} → {transfert.nom} {transfert.prenom}
                </span>
              </div>
              <p className="mt-1 text-xs text-outline">
                Créé le {formatDate(transfert.createdAt)} · accepté {formatDate(transfert.acceptedAt)} · annulé{' '}
                {formatDate(transfert.cancelledAt)}
              </p>
              <p className="font-mono text-[11px] text-surface-variant">
                émetteur {transfert.guidEmetteur} · récepteur {transfert.guidRecepteur ?? '—'}
              </p>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}
